module.exports = __webpack_public_path__ + "static/media/warning.a4a7cbc0.svg";